import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme/src/types/colors.types';

const Styled = styled.div`
    display: flex;
    text-align: center;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
`;

export interface ImageGalleryTrackProps {
    activeSlideIndex: number;
    setActiveSlideIndex: (index: number) => void;
    slidesLength: number;
    accentColor?: AccentColorOptions;
}

const Circle = styled.div<{active?: boolean; accentColor: AccentColorOptions}>`
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background-color: ${(p) =>
        p.active
            ? p.theme.palette.accent[p.accentColor]
            : p.theme.ifLight(p, p.theme.palette.neutral.silver, p.theme.palette.neutral.steel)};
    margin: 0 15px;
    cursor: pointer;
`;

export const ImageGalleryTrack = ({
    activeSlideIndex,
    setActiveSlideIndex,
    slidesLength,
    accentColor = 'sky'
}: ImageGalleryTrackProps): JSX.Element | null => {
    if (slidesLength < 2) return null;

    const dots: JSX.Element[] = [];
    for (let i = 0; i < slidesLength; i++) {
        dots.push(
            <Circle
                key={`image-gallery-track-dot-${i}`}
                accentColor={accentColor}
                active={i === activeSlideIndex}
                onClick={() => {
                    setActiveSlideIndex(i);
                }}
            />
        );
    }
    return <Styled>{dots}</Styled>;
};
